(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var div_top = $('#sticky-anchor').offset().top - 150;
    if (window_top > div_top) {
        $('#absolute-sidebar').addClass('stick');
        $('#sticky-anchor').height($('#sticky').outerHeight());
    } else {
        $('#absolute-sidebar').removeClass('stick');
        $('#sticky-anchor').height(0);
    }
}

$(function () {
    //$(window).scroll(sticky_relocate);
    //sticky_relocate();
    $(window).on('scroll', function () {
        var y_scroll_pos = window.pageYOffset;
        var scroll_pos_test = 100; // set to whatever you want it to be

        if (y_scroll_pos > scroll_pos_test) {
            $('.nav-inner').css('background-color', '#333');
            $('nav#main-nav ul li ul li').css('background-color', '#333');
        } else {
            $('.nav-inner').css('background-color', 'rgba(0, 0, 0, 0.4)');
            $('nav#main-nav ul li ul li').css('background-color', 'rgba(0, 0, 0, 0.4)');
        }
        if ($(window).scrollTop() + $(window).height() == $(document).height()) {
            if ($('body').hasClass('bottom-reached')) {} else {
                if ($.cookie('dismissedForm') !== 'yes') {
                    $('body').addClass('bottom-reached');
                    $('#subscribe-form').addClass('active');
                }
            }
        }
    });
});

$(document).ready(function () {
    $('.lightbox-trigger').on('click', 'a', function (event) {
        event.preventDefault();
        $('#popupForm').foundation('reveal', 'open');
    });
    $('#testimonials').masonry({
        // set itemSelector so .grid-sizer is not used in layout
        itemSelector: '.widget-wysiwyg',
        // use element for option
        columnWidth: '.postWidth'
    });
    $(".client-slider").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
            breakpoint: 1000,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 650,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 500,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 400,
            settings: {
                slidesToShow: 1
            }
        }]
    });
    $('#menuToggle').click(function () {
        $('#menuToggle').toggleClass('activated');
        $('nav#main-nav > ul').toggle();
    });

    $('#subscribe-form').on('click', '.handle', function () {
        $('#subscribe-form').toggleClass('active');
    }).on('click', '.dismiss', function () {
        $('#subscribe-form').toggleClass('active');
        $.cookie('dismissedForm', 'yes', { expires: 14 });
    });
});

//Finance Calculator
var $additionalFeatures = 0;

function addCommas(nStr) {
    nStr += '';
    var $x = nStr.split('.'),
        $x1 = $x[0],
        $x2 = $x.length > 1 ? '.' + $x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test($x1)) {
        $x1 = $x1.replace(rgx, '$1' + ',' + '$2');
    }
    return $x1 + $x2;
}

function calculateCost() {
    var $pageCount = $('#pageCount').val(),
        $hourlyRate = 98,
        $javaExchangeRate = 200,
        $scaleFactor = $pageCount * 0.5,
        $coreHours = 30 + $scaleFactor * 4,
        $total = ($coreHours + $additionalFeatures) * 1.2,
        $lowerCost = ($total * $hourlyRate * 0.9).toFixed(0),
        $upperCost = ($total * $hourlyRate * 1.1).toFixed(0),
        $coffeeCount = ($lowerCost / $javaExchangeRate).toFixed(0);
    if ($pageCount >= 100) {
        $pageCount = '100+';
    }
    $('#outputpageCount').text($pageCount);
    $('#outputCoreHours').val($coreHours);
    $('#outputAdditionalHours').val($additionalFeatures);
    $('#outputPMHours').val($total - ($coreHours + $additionalFeatures));
    $('#outputConentPop').val($scaleFactor);
    $('#outputTotalHours').val($total);
    if ($('.costOutput').hasClass('coffeeProvidings')) {
        $('.costOutput ul').html('<li></li>'.repeat($coffeeCount));
        $('.costOutput p').html('<span>' + $coffeeCount + '</span>' + ' Golden Coffee Beans**');
    } else {
        $('.costOutput').text('£' + addCommas($lowerCost) + ' - £' + addCommas($upperCost));
    }
}

var $websiteCalcForm = $('.website-calc');
$websiteCalcForm.on('change', 'input.switchyMcSwitchSwitch', function () {
    $additionalFeatures = 0;
    $('input.switchyMcSwitchSwitch').each(function () {
        if (this.checked) {
            $additionalFeatures = $additionalFeatures + parseInt($(this).attr('data-value'), 10);
        }
    });
    calculateCost();
});

$(document).foundation({
    slider: {
        on_change: function on_change() {
            calculateCost();
        }
    },
    equalizer: {
        // Specify if Equalizer should make elements equal height once they become stacked.
        equalize_on_stack: true
    }
});

},{}]},{},[1]);
